import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import ScrollDownButton from "./components/ScrollDownButton";
import useIsMobile from "./hooks/useIsMobile";
import About from "./pages/About";
import Contacts from "./pages/Contacts";
import Events from "./pages/Events";
import Home from "./pages/Home";
import Mission from "./pages/Mission";
import Team from "./pages/Team";
import What from "./pages/What";
import "./styles/App.css";

function App() {
  const isMobile = useIsMobile(801);
  return (
    <div className="wrapper">
      <Navbar isVisible={!isMobile} />
      <ScrollDownButton />
      <Home />
      <About />
      <Team />
      <Mission />
      <What />
      <Events />
      <Contacts />
      <Footer
        companyName={"MNR - Clínica de Psicologia"}
        creatorName={"João Pedro Lopes"}
        creatorEmail={"joaopedrofrancelalopes@gmail.com"}
      />
    </div>
  );
}

export default App;
